/**
 * Dicionario de mapeamento de providers customizados para IDs do Firebase Identity Platform.
 *
 * Clientes legados ja usam query params simplificados (ex: ?provider=prosus, ?provider=olxbr, ?provider=despegar)
 * sem o prefixo de protocolo. Este dicionario mantem retrocompatibilidade mapeando esses nomes
 * para o provider ID completo do Firebase (oidc.* ou saml.*).
 *
 * Para novos providers, o valor do query param pode ser passado ja com o prefixo completo
 * (ex: ?provider=oidc.novo-provider) e sera usado diretamente sem passar pelo dicionario.
 */
export const CUSTOM_PROVIDER_MAP = {
  prosus: 'oidc.prosus',
  olxbr: 'saml.olxbr',
  despegar: 'saml.despegar',
}

/**
 * Nome de exibicao para providers legados no botao de login.
 * Prosus exibe "okta" por ser o IdP configurado pelo cliente.
 * Providers nao listados usam o proprio nome do query param.
 */
export const PROVIDER_DISPLAY_NAME = {
  prosus: 'okta',
}

/**
 * Valida o formato do query param provider.
 * Aceita apenas caracteres alfanumericos, pontos, hifens e underscores
 * para prevenir injection via query param.
 */
const VALID_PROVIDER_PATTERN = /^[a-zA-Z0-9._-]+$/

export function isValidProvider(provider) {
  return typeof provider === 'string' && VALID_PROVIDER_PATTERN.test(provider)
}
